import CryptoJS from "crypto-js";

// Encryption function
export const encryptData = (data, secretKey) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

// Decryption function
export const decryptData = (ciphertext, secretKey) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  try {
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

const setItem = (key,state) => {
    try {
      const encryptedState = encryptData(state, key);
      localStorage.setItem(key, encryptedState);
    } catch (error) {
      console.error("Error saving state:", error);
    }
  };
  
  const getItem = (key) => {
    try {
      const encryptedState = localStorage.getItem(key);
      if (!encryptedState || encryptedState === undefined) return null;
      return decryptData(encryptedState, key);
    } catch (error) {
      console.error("Error loading state:", error);
      return undefined;
    }
  };

  export { setItem, getItem}


  